







import { defineComponent, ref } from "@vue/composition-api";
import { ContentPriceSubjectTypeEnum } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { InputIuguBoletoDetails, BoletoResponse } from "@scrile/api-provider/dist/api/IuguPurchaseProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { RecurringBillingScheduleSubjectTypeEnum } from "@scrile/api-provider/dist/api/RecurringBillingScheduleProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import providers from "@/lib/api";
import { getMainCurrencyCode } from "@/lib/moneyHelpers";
import BoletoEditView from "@/payments/integrations/Iugu/components/BoletoEditView.vue";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "BoletoType",
  components: { BoletoEditView, ModalView, PageTitle },
  props: {
    pricePackageId: { type: String, required: true },
    paymentSystem: { type: Object as () => PaymentSystemPublic, required: true },
    price: { type: String },
    purchaseSubject: { type: Object as () => Subject<ContentPriceSubjectTypeEnum> },
    subscriptionSubject: { type: Object as () => Subject<RecurringBillingScheduleSubjectTypeEnum> },
  },
  setup(props, { emit }) {
    const show = ref(false);
    const processing = ref(false);
    const invoiceUrl = ref("");
    const onSubmit = async (data: InputIuguBoletoDetails) => {
      try {
        processing.value = true;
        let response: BoletoResponse;
        if (!props.subscriptionSubject) {
          response = await providers.IuguPurchaseProvider.iuguGenerateBoletoInvoice({
            data: {
              pricePackageId: props.pricePackageId,
              paymentSystemId: props.paymentSystem.id,
              currency: getMainCurrencyCode(),
              billingDetails: data,
              subject: props.purchaseSubject ?? undefined,
            },
          });
        } else {
          response = await providers.IuguPurchaseProvider.iuguGenerateBoletoRecurringInvoice({
            data: {
              paymentSystemId: props.paymentSystem.id,
              currency: getMainCurrencyCode(),
              billingDetails: data,
              subject: props.subscriptionSubject,
            },
          });
        }
        invoiceUrl.value = response.invoiceUrl;
      } finally {
        processing.value = false;
      }
    };

    const onClose = () => {
      if (invoiceUrl.value) {
        emit("submit", { type: "boleto", purchaseSubject: props.subscriptionSubject || props.purchaseSubject });
      } else {
        emit("close");
      }
    };

    return {
      show,
      onSubmit,
      onClose,
      invoiceUrl,
      processing,
    };
  },
});
